import type { IconData } from '@stacksjs/iconify-core'

export const paragraph: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M13 15.5H3a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2m8-5H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default paragraph
